// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pXPD","actions":"styles_actions__376Uk","error":"styles_error__B2ocm","message":"styles_message__1aJgh"};